import React, { useEffect, useState } from "react";
import { ISorter } from "../../models/interfaces/ISorter";
import { useKeycloak } from "@react-keycloak/web";
import { ILocation } from "../../models/interfaces/ILocation";
import { ITitle } from "../../models/interfaces/ITitle";
import CpntDataTable from "../../components/dataTable/CpntDataTable";
import CpntPagination from "../../components/CpntPagination";
import { filterToQuery, getDefaultFilterFichiersAlertePoches, IFilterFichiersAlertePoches, IFilterFichiersAlertePochesDTO } from "../../models/interfaces/IFilterFichiersAlertePoches";
import { useFetchFichiersAlertePochesQuery } from "../../redux/slice/api/FO/AlertePochesApi";
import { AlertePochesFichier, AlertePochesFichierList } from "../../models/interfaces/IFichierAlertePoches";
import SpinnerEditeurPro from "./components/SpinnerEditeurPro";
import { Modules } from "../../config/helpers";



const PageModuleAlertePoche: React.FC = () => {

  const [listfilter, setListFilter] = useState<IFilterFichiersAlertePoches>();
  const [searchParams, setSearchParams] = useState<IFilterFichiersAlertePochesDTO|undefined>(undefined);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [isDescending, setIsDescending] = useState<boolean>();
  const [sortField, setSortField] = useState("");
 

  useEffect(() => {
    const storedFilter = localStorage.getItem("IFilterComptes");
    const storedSorter = localStorage.getItem("ISortStore");

    if (storedFilter !== null && storedFilter !== undefined) { // && storedSorter !== null && storedSorter !== undefined) {
      setListFilter(JSON.parse(storedFilter));
    } else {
      setListFilter(getDefaultFilterFichiersAlertePoches());
    }

    if (storedSorter !== null && storedSorter !== undefined) {
      const currSorter:ISorter = JSON.parse(storedSorter);
      currSorter?.orderedcolumnid && setSortField(currSorter?.orderedcolumnid);
      currSorter?.orderedasc && setIsDescending(!currSorter?.orderedasc);
    }
   
  }, []);

  useEffect(() => {
    if (listfilter && listfilter !== getDefaultFilterFichiersAlertePoches()) {
      const _filter: IFilterFichiersAlertePochesDTO = filterToQuery({
        ...listfilter,
        ...(sortField && { SortField: sortField }),
        ...(isDescending !== null && { IsDescending: isDescending }),
        ...(limit >= 0 && { Limit: limit }),
        ...(offset >= 0 && limit >= 0 && { Offset: offset }),
      });
      setSearchParams(_filter);
    }
  }, [listfilter, sortField, isDescending, offset, limit]);

  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
  const { data: FichierAlertePochesResult, isFetching, error } = useFetchFichiersAlertePochesQuery(searchParams, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || searchParams === null || searchParams === undefined || listfilter === undefined,
  });


  // const applyFilter = (data: IFilterFichiersAlertePoches) => {
  //    //data.FacettesFiltre = [];
  //   setListFilter(data);
  //   setOffset(0);
  //    setLimit(10);
  // }

const actions: ILocation[] = [
  {
    PathsName: (index) => { 
      const marque = FichierAlertePochesResult?.AlertePochesFichiers?.[index]?.MarquesLibelles || ""; // Provide a default value
      return { [marque]: "" };
    },
    State: { type_access: "" },
    ClassName: "bi bi-info-circle",
  },
    {
      PathsName: {Télécharger:"" },
      State: { type_access: "" },
      ClassName: "bi bi-download Action-button",
      ActionCallBack: (index) => {
        const file = FichierAlertePochesResult?.AlertePochesFichiers[index];
        if (file && file.Data !== null) {
          handleDownloadSingle(file); // Pass the file directly, guaranteed to be defined
          return true;
        } 
        return false; // Return false if no file or no data is available
      }
    }
    
    
  ];
  
  

  const dataHeaderName: ITitle[] = [
    
    {
      Id: "Id",
      Name: "Id",
      Class: "",
      sorter: (a: AlertePochesFichierList, b: AlertePochesFichierList) =>
        a.Id - b?.Id,
    },
    
    {
      Id: "Nom",
      Name: "Nom",
      Class: "",
      sorter: (a: AlertePochesFichierList, b: AlertePochesFichierList) =>
        a?.Nom?.localeCompare(b?.Nom),
    },
    {
        Id: "DateCreation",
        Name: "Date de création",
        Class: "desktop-only-section",
        sorter: (a: AlertePochesFichierList, b: AlertePochesFichierList) =>
          (a.DateCreation || "").localeCompare(b.DateCreation || "", "fr"),
  },
    {
          Id: "PeriodeDateDebut",
          Name: "Période Date Début",
          Class: "desktop-only-section",
          sorter: (a: AlertePochesFichierList, b: AlertePochesFichierList) =>
            (a.PeriodeDateDebut || "").localeCompare(b.PeriodeDateDebut || "", "fr"),
    },
    {
          Id: "PeriodeDateFin",
          Name: "Période Date Fin",
          Class: "desktop-only-section",
          sorter: (a: AlertePochesFichierList, b: AlertePochesFichierList) =>
            (a.PeriodeDateFin || "").localeCompare(b.PeriodeDateFin || "", "fr"),
    },
    {
          Id: "PeriodeDateFin",
          Name: "Période Date Fin",
          Class: "desktop-only-section",
          sorter: (a: AlertePochesFichierList, b: AlertePochesFichierList) =>
            (a.PeriodeDateFin || "").localeCompare(b.PeriodeDateFin || "", "fr"),
    },
    
  ];
  
  const handleDownloadSingle = (file: AlertePochesFichier) => {
    if (file.Data) {
      const uint8Array = new Uint8Array(file.Data);
  
      // Ajoutez un BOM UTF-8 au début des données pour garantir un bon encodage
      const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
  
      // Création d'un Blob avec le BOM ajouté
      const blob = new Blob([bom, uint8Array], { type: "text/csv;charset=utf-8;" });
  
      // Nom du fichier (utilisez le champ `Nom` ou un fallback)
      const fileName = file.Nom ? `${file.Nom}.csv` : `fichier_${file.Id || "inconnu"}.csv`;
  
      // Création d'un URL pour le Blob
      const url = URL.createObjectURL(blob);
  
      // Création d'un lien temporaire pour le téléchargement
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
  
      // Ajout du lien au DOM, déclenchement du clic, et suppression
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  
      // Libération de l'URL
      URL.revokeObjectURL(url);
    } else {
      alert("Aucun fichier disponible pour ce téléchargement.");
    }
  };
  
  const dataItemsStyle = {
    Id: "",
    Nom: "",
    PeriodeDateDebut: "",
    PeriodeDateFin:"",
    DateCreation:"",
  };
  
return (
  <div className="container text-center">
      <div className="row pt-3 pb-2">
        <div className="col col-12 ">
          <h2 className="titreModule titre-bleu"><i className="bi-filetype-csv pe-2" />{Modules.AlertePoche}</h2>
        </div>
      </div>
      <div className="row pt-3 pb-5">
        <div className="col col-md-10 offset-md-1 col-12 ">
        {/* <div className="row card mb-2 mt-2">*/}
          {/* {searchParams && ( */}
            <>
              {/* <FichiersAlertePochesFilter
                filter={dtoToFilter(searchParams)}
                changeFilter={applyFilter}
              /> */}
              {/* {NoticesResult?.Facettes &&
                <CpntFacette FacettesSelected={searchParams?.FacettesFiltre} Facettes={NoticesResult?.Facettes} onChange={(filtre,checked) => changeFacette(filtre,checked)} />
              }    */}
            </>
          {/* )} */}
           
        {/* </div>   */}
        
        <div className="row ">
          {FichierAlertePochesResult?.Quantite !== null && FichierAlertePochesResult?.AlertePochesFichiers && 
            <div className="col-auto pb-3 pt-3">
              Nb de résultats :<b>&nbsp;{FichierAlertePochesResult.Quantite}&nbsp;</b>
             </div>
          }
          {isFetching ? (
            <SpinnerEditeurPro />
          ) : error ? (
            <div>Error</div>
          ) : (
            <>
            {FichierAlertePochesResult?.AlertePochesFichiers && FichierAlertePochesResult?.Quantite !== null && FichierAlertePochesResult.Quantite > 0 &&
              <>
                <CpntPagination limit={limit} offset={offset} numberOfResults={FichierAlertePochesResult.Quantite} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination>

              <div className="card p-0 mb-2">
                <div className="table-responsive">
                  <CpntDataTable
                    data={FichierAlertePochesResult && FichierAlertePochesResult.AlertePochesFichiers ? [...FichierAlertePochesResult.AlertePochesFichiers] : []}
                    dataHeader={dataHeaderName}
                    dataItemsStyle={dataItemsStyle}
                    actions={actions}
                    actualFilterPage="PageAlertePochesFichiers"
                    updateSorter={setSortField}
                    updateDescending={setIsDescending}
                />
                </div>
              </div>
              <CpntPagination limit={limit} offset={offset} numberOfResults={FichierAlertePochesResult.Quantite} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination>
              </>}
              </>
          )}
        </div>
        </div>
      </div>
    </div>
  );
  
};

export default PageModuleAlertePoche;




